/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { ColorAlias, getThemeColorFromAlias, theme } from "../../theme";

interface LogoProps {
  onClick?: () => void;
  color?: ColorAlias;
}

const MapfreLogo: FC<LogoProps> = ({ onClick, color }) => {
  const logoColor = color
    ? getThemeColorFromAlias(color, theme.colors)
    : getThemeColorFromAlias("Green", theme.colors);
  return (
    <span onClick={onClick}>
      <svg
        height="25"
        viewBox="0 0 152 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8591 1.47049C25.6323 1.47049 32.7183 9.04671 32.7183 18.3464C32.7183 27.682 25.5985 35.2223 16.8591 35.2223C8.08599 35.2223 1 27.6461 1 18.3464C1 9.04671 8.11974 1.47049 16.8591 1.47049Z"
          stroke={logoColor}
          strokeMiterlimit="10"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8588 3.08582C8.92926 3.08582 2.48438 9.94391 2.48438 18.3819C2.48438 26.8198 8.92926 33.6779 16.8588 33.6779C24.7884 33.6779 31.2333 26.8198 31.2333 18.3819C31.2333 9.94391 24.7884 3.08582 16.8588 3.08582Z"
          stroke={logoColor}
          strokeMiterlimit="10"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8591 1.47049C8.08599 1.47049 1 9.04671 1 18.3464C1 27.682 8.11973 35.2224 16.8591 35.2224C25.6323 35.2224 32.7182 27.6461 32.7182 18.3464C32.752 9.04671 25.6323 1.47049 16.8591 1.47049ZM16.8591 33.6425C8.92956 33.6425 2.48468 26.7844 2.48468 18.3464C2.48468 9.90845 8.92956 3.05037 16.8591 3.05037C24.7887 3.05037 31.2336 9.90845 31.2336 18.3464C31.2336 26.8203 24.7887 33.6425 16.8591 33.6425Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1316 12.2063C20.4691 12.3499 20.739 12.7449 20.739 13.1757C20.739 13.3912 20.6715 13.6066 20.5703 13.7861L17.331 19.7466C17.2635 19.9261 17.0948 20.0338 16.8923 20.0338C16.6899 20.0338 16.5211 19.9261 16.4537 19.7466L13.2143 13.7861C13.1131 13.6066 13.0456 13.4271 13.0456 13.2116C13.0456 12.7808 13.2818 12.4576 13.6193 12.2781C13.653 12.2781 13.653 12.2422 13.6867 12.2422C14.699 11.8472 15.7788 11.6318 16.8923 11.6318C18.0396 11.6318 19.1193 11.8472 20.1316 12.2422C20.1316 12.1704 20.1316 12.2063 20.1316 12.2063ZM10.5824 14.1452C10.8186 13.9657 11.156 13.9298 11.4597 14.0734C11.5947 14.1811 11.7297 14.2888 11.7971 14.4684L14.4291 19.3157C14.4966 19.4593 14.5303 19.603 14.4291 19.7466C14.3616 19.8902 14.1929 19.962 14.0579 19.962H8.79404C8.62533 19.962 8.49035 19.9261 8.32164 19.8543C8.0517 19.6748 7.91672 19.3516 7.91672 19.0644C7.91672 19.0285 7.91672 19.0285 7.91672 18.9925C8.0517 18.0949 8.35538 17.1972 8.82778 16.3355C9.33392 15.5096 9.90755 14.7556 10.5824 14.1452ZM23.1347 14.1452C22.8985 13.9657 22.5611 13.9298 22.2574 14.0734C22.1224 14.1811 21.9875 14.2888 21.92 14.4684L19.3218 19.3157C19.2543 19.4593 19.2206 19.603 19.3218 19.7466C19.3893 19.8902 19.558 19.962 19.693 19.962H24.9568C25.1256 19.962 25.2605 19.9261 25.4292 19.8543C25.6992 19.6748 25.8342 19.3516 25.8342 19.0644C25.8342 19.0285 25.8342 19.0285 25.8342 18.9925C25.6654 18.0949 25.3955 17.1972 24.9231 16.3355C24.417 15.5096 23.8433 14.7556 23.1347 14.1452C23.1685 14.1452 23.1685 14.1452 23.1347 14.1452ZM17.6684 21.6496V26.8201H16.1162V21.6496C15.3739 21.6496 14.3953 21.6496 14.0242 21.6137H8.86152C8.42287 21.6496 7.98421 21.5419 7.5793 21.2905C6.80321 20.8238 6.36456 19.9261 6.3983 19.0285C6.3983 18.8848 6.3983 18.7771 6.43204 18.6694C6.60076 17.5922 6.97192 16.4791 7.54555 15.4737C8.08544 14.4684 8.79404 13.5707 9.60387 12.8526C10.1438 12.4217 10.8861 12.2063 11.5947 12.3499C11.7971 11.6318 12.2358 11.0573 12.8432 10.7341C12.9444 10.6623 13.0794 10.6264 13.1469 10.5905C14.3279 10.1237 15.5763 9.90826 16.8923 9.90826C18.2083 9.90826 19.4905 10.1596 20.6378 10.6264C21.3126 10.9495 21.92 11.5959 22.1562 12.3858C22.8311 12.2063 23.5059 12.3858 24.0458 12.8167C24.8556 13.5348 25.6654 14.5043 26.2053 15.5096C26.7452 16.515 27.1164 17.5922 27.2851 18.7053C27.2851 18.813 27.3188 18.9207 27.3188 19.0644C27.3526 19.962 26.9139 20.8597 26.1378 21.3265C25.7329 21.5778 25.2943 21.6855 24.8556 21.6496H19.693C19.3555 21.6496 18.4107 21.6496 17.6684 21.6496Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.5529 9.51312L50.4333 17.987L54.28 9.51312H60.1512V26.425H54.28V17.987L50.4333 26.425L46.5529 17.987V26.425H40.6816V9.51312H46.5529Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62.041 26.4255L66.5963 9.54959H76.9553L81.5106 26.4255H75.6394L74.897 23.6607H68.6546L67.9123 26.4255H62.041ZM71.759 12.063L69.3632 20.896H74.121L71.759 12.063Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.3317 9.54959C96.8961 9.54959 98.9544 11.7399 98.9544 14.4687C98.9544 17.1976 96.8961 19.3879 94.3317 19.3879H89.2365V26.4255H83.3652V9.54959H94.3317ZM90.6199 11.4526C91.9359 11.4526 93.2181 12.2067 93.2181 13.7506C93.2181 15.2946 92.0709 16.5154 90.6199 16.5154H89.3377V11.4526H90.6199Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M101.014 9.51312H116.569V12.3138H106.851V16.5867H116.569V19.3514H106.851V26.425H101.014V9.51312Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M142.281 23.6602H151.999V26.425H136.41V9.51312H151.999V12.3138H142.281V16.5867H151.999V19.3514H142.281V23.6602Z"
          fill={logoColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M134.217 22.1886V26.4255H128.447V22.3322C128.447 22.2963 128.447 22.2245 128.447 22.1886C128.447 20.6446 127.266 19.4238 125.848 19.4238H124.566V26.4255H118.594V9.54959H130.235C132.428 9.54959 134.217 11.4526 134.217 13.7865C134.217 16.1204 132.428 18.0235 130.235 18.0235C132.395 18.0235 134.149 19.8547 134.217 22.1168C134.217 22.1168 134.217 22.1527 134.217 22.1886ZM134.217 22.045V22.1886C134.217 22.1527 134.217 22.1168 134.217 22.045ZM125.848 11.4885C127.131 11.4885 128.447 12.2426 128.447 13.7865C128.447 15.3305 127.266 16.5513 125.848 16.5513H124.566V11.4885H125.848Z"
          fill={logoColor}
        />
      </svg>
    </span>
  );
};

export default MapfreLogo;
